<div class="table-with-input-preview">
  <irembogov-data-table
    [columns]="columns"
    [searchable]="false"
    [selectable]="false"
    [data]="data"
    [minimalPagination]="true">
  </irembogov-data-table>
  <div *ngIf="count" class="table-with-input-item-count-row">
    <span class="table-with-input-item-count">
      {{ count }} {{ (count === 1 ? 'item' : 'items') | translate }}
    </span>
  </div>
</div>
